module.exports = __webpack_public_path__ + "images/psp/SizeGuide/personal-wine-lockers.svg";